export default "__VITE_ASSET__CEjM_Na$__"